<elm-app-layout>
  <elm-app-background *ngIf="(headerBackground$ | async) as background" [background]="background"></elm-app-background>

  <elm-app-header> <elm-app-logo [alt]="title$ | async" [src]="logo$ | async"></elm-app-logo> </elm-app-header>
</elm-app-layout>
